export const MINSIDE_REFERRALPARTY_FIRST_LINE_FILTER = '54ae4873-3467-e911-a857-000d3ab4dfbd';
